import { render, staticRenderFns } from "./CurrentCompany.vue?vue&type=template&id=39f684f8"
import script from "./CurrentCompany.vue?vue&type=script&lang=js"
export * from "./CurrentCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports